import instance from "./axios.config";

const addCategory = (payload) =>
    instance.post("/category", payload);

const getAllcategory = () =>
    instance.get(`/category`);

const updateCategory = (id, payload) =>
    instance.put(`/category/${id}`, payload);

const deleteCategory = (id) => instance.delete(`/category/${id}`);


const categoryService = {
    addCategory,
    getAllcategory,
  updateCategory,deleteCategory

};
export default categoryService;
